export { default } from "./InputNumber";
